<template>
  <v-row>
    <v-col cols="3">
      <v-sheet color="transparent" style="position:sticky; top:100px">
        <v-card width="180px" outlined>
          <v-card-text>
            <v-responsive class="align-center text-center" :aspect-ratio="1/1">
              <img :src="require(`@/assets/appAsset-brand--${biller.brand}.svg`)" :alt="biller.title" height="40px">
            </v-responsive>
          </v-card-text>
        </v-card>
        <v-list class="pl-0" color="transparent">
          <v-list-item class="pl-0">
            <v-list-item-content class="d-block text--secondary font-weight-medium">Compatibilidad</v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Países</v-list-item-title>
              <v-list-item-subtitle class="d-block pt-1 caption text--primary">
                <img class="mr-2" :src="require('@/assets/appAsset-flag--CL.svg')" :alt="biller.title" height="16px">
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Tipos de facturas</v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                <span class="d-block mb-1 caption text--primary" v-for="d in biller.invoiceTypes" :key="d">{{d}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="pl-0">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">Otros tipos de documentos</v-list-item-title>
              <v-list-item-subtitle class="pt-1">
                <span class="d-block mb-1 caption text--primary" v-for="d in biller.otherTypes" :key="d">{{d}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-col>

    <v-col cols="9">
      <v-row>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="ml-n1 subtitle-1 text--secondary font-weight-medium">
            <router-link :to="{ name: 'Integrations' }" class="subtitle-1 routerLink font-weight-medium">Integraciones</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>{{biller.name}}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-1" :to="{ name: 'PurchaseList' }" outlined color="secondary">Administrador de compras</v-btn>
              <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-1" v-bind="attrs" v-on="on" retain-focus-on-click outlined color="secondary" :ripple="false"><v-icon left>mdi-chart-box</v-icon>Reportes<v-icon right>mdi-chevron-down</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" :to="{ name: 'BillersBuiltInReportTransactional' }" :ripple="false">
                    <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Transaccional</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-5 py-1" :to="{ name: 'BillersBuiltInRvds' }" :ripple="false">
                    <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">Resumen de ventas diarias (RVD)</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
      </v-row>
      <v-row no-gutters>
        <v-col md="3">
          <span class="d-block caption">Documentación</span>
          <v-btn :href="`${$DOCS_BASE}${biller.docs}`" target="_blank" color="primary" text :ripple="false">Ir a la documentación<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-col>
        <v-divider vertical />
        <v-col md="3" class="ml-2">
          <span class="d-block caption">Sitio web</span>
          <v-btn :href="biller.website" target="_blank" color="primary" text :ripple="false">Visitar el sitio<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="!hasSequences">
          <v-alert class="mb-0 body-2" dark dense prominent color="indigo" border="left" type="info">
            <v-row align="center">
              <v-col class="grow">
                Si actualmente usas el <span class="font-weight-medium">software de facturación gratuito del SII</span> es necesario que solicites la certificación de tu empresa para poder usar <span class="font-weight-medium">Piriod</span>
              </v-col>
              <v-col class="shrink">
                <v-btn @click="intercomNewMessage('Hola, quiero certificar mi empresa en el SII para poder usar Piriod')" color="indigo darken-3">Solicitar certificación</v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
        <v-col cols="12">
          <!-- sii activation onboarding -->
          <v-card class="mb-5" v-if="!hasCertificate || !hasSequences || !hasBillerConnection">
            <v-toolbar flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Activación de la facturación incorporada</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="px-0">
              <v-row class="mx-0" align="center">
                <v-col class="text-center">
                  <v-progress-circular :rotate="260" :size="120" :width="12" :value="activation" color="primary">
                    <span class="title">{{activation}}%</span>
                  </v-progress-circular>
                </v-col>
                <v-divider vertical />
                <v-col class="text-center">
                  <v-icon v-if="hasCertificate" color="primary" size="32">mdi-check-circle</v-icon>
                  <v-icon v-else color="secondary" size="32">mdi-account-check</v-icon>
                  <span class="d-block mt-4 body-2 text--secondary font-weight-medium">Certificado digital</span>
                  <span class="d-block mt-2" :class="{ 'mb-10': hasCertificate }">Es requerido para firmar tus facturas electrónicamente</span>
                  <v-btn class="mt-3" v-if="!hasCertificate" @click="$vuetify.goTo($refs.certificate, { offset: 20 })" outlined small>Cargar</v-btn>
                </v-col>
                <v-divider vertical />
                <v-col class="text-center">
                  <v-icon v-if="hasSequences" color="primary" size="32">mdi-check-circle</v-icon>
                  <v-icon v-else color="secondary" size="32">mdi-numeric-1-box-multiple-outline</v-icon>
                  <span class="d-block mt-4 body-2 text--secondary font-weight-medium">Folios</span>
                  <span class="d-block mt-2" :class="{ 'mb-10': hasSequences }">Piriod asignará un número correlativo autorizado a tus facturas</span>
                  <v-btn class="mt-3" v-if="!hasSequences" @click="$vuetify.goTo($refs.folios, { offset: 20 })" outlined small>Cargar</v-btn>
                </v-col>
                <v-divider vertical />
                <v-col class="text-center">
                  <v-icon v-if="hasBillerConnection" color="primary" size="32">mdi-check-circle</v-icon>
                  <v-icon v-else color="secondary" size="32">mdi-domain</v-icon>
                  <span class="d-block mt-4 body-2 text--secondary font-weight-medium">Información fiscal</span>
                  <span class="d-block mt-2" :class="{ 'mb-10': hasBillerConnection }">Requerido para que tus facturas estén en norma con el SII</span>
                  <v-btn class="mt-3" v-if="!hasBillerConnection" @click="$vuetify.goTo($refs.taxsettings, { offset: 20 })" outlined small>Actualizar información</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- end sii activation onboarding -->

          <!-- digital certificate -->
          <v-card ref="certificate" class="mb-5">
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
                Certificado digital
                <v-tooltip v-if="certificatesDetail.date_end && dateIsBefore(certificatesDetail.date_end, today)" right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="red">mdi-information</v-icon>
                  </template>
                  <span>El certificado digital está vencido. Tus facturas por suscripción, únicas o masivas no pueden ser creadas. Para resolver el problema compra un nuevo certificado y súbelo a Piriod.</span>
                </v-tooltip>
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-row align="center" justify="center" class="mr-1">
                  <v-btn @click="modalCertificate=true" outlined color="secondary"><v-icon left>mdi-plus</v-icon> Nuevo certificado</v-btn>
                </v-row>
              </v-toolbar-items>
            </v-toolbar>
            <v-divider />
            <v-card-text class="px-0 background">
              <v-skeleton-loader class="mt-5" v-if="mainLoader" transition="fade-transition" type="table" />
              <template v-else-if="certificatesDetail.name">
                <v-list class="v-list-form-extended transparent">
                  <v-list-item>
                    <v-list-item-title>Nombre</v-list-item-title>
                    <v-list-item-subtitle>{{certificatesDetail.name}} • RUN {{certificatesDetail.run}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Validez</v-list-item-title>
                    <v-list-item-subtitle>desde el {{certificatesDetail.date_start | date}} hasta el {{certificatesDetail.date_end | date}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Emisor</v-list-item-title>
                    <v-list-item-subtitle>{{certificatesDetail.maker}}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </template>
              <v-row class="mx-0" v-else>
                <v-col class="py-2 text-center">
                  <v-icon class="d-block" color="secondary" size="70">mdi-account-check</v-icon>
                  <span class="d-block subtitle-1 my-2">Aún no tienes certificados</span>
                  <v-btn @click="modalCertificate=true" outlined>Nuevo certificado</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- end digital certificate -->

          <!-- folios -->
          <v-card ref="folios" class="my-5">
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Folios</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-row align="center" justify="center" class="mr-1">
                  <v-btn class="ml-5" @click="dialogCreateFolio=true" outlined>Subir folio</v-btn>
                </v-row>
              </v-toolbar-items>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0 background">
              <v-skeleton-loader class="mt-5" v-if="mainLoader" transition="fade-transition" type="table" />
              <template v-else>
                <v-expansion-panels v-model="expansionPanelCafs" v-if="sequencesList.length" accordion tile flat>
                  <v-expansion-panel v-for="(d, i) in sequencesList" :key="d.id">
                    <v-expansion-panel-header>
                      <v-row no-gutters align="center" justify="space-between">
                        <v-col>
                          <span class="d-block body-2 text--secondary font-weight-medium">
                            {{d.document.name}}
                            <v-tooltip v-if="!cafExists(d.document.id, d.next_number)" right max-width="280px" transition="scale-transition">
                              <template v-slot:activator="{on}">
                                <v-icon v-on="on" small color="red">mdi-information</v-icon>
                              </template>
                              <span>No tienes folios disponibles para <span class="text--secondary font-weight-medium">{{d.document.name}}</span>. Solicita y sube un folio para resolver el problema.</span>
                            </v-tooltip>
                          </span>
                        </v-col>
                        <v-col v-if="expansionPanelCafs === i">
                          <v-tooltip max-width="280px" top transition="scale-transition">
                            <template v-slot:activator="{on}">
                              <v-icon class="mt-n1" v-on="on" small color="secondary">mdi-information</v-icon>
                            </template>
                            <span>Es el número que será asignado al siguente documento de tipo <span class="text--secondary font-weight-medium">{{d.document.name}}</span> que sea creado.</span>
                          </v-tooltip>
                          Núm. siguiente {{d.next_number}}
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row class="mx-0">
                        <v-col class="px-0" cols="12">
                          <v-card class="overflow-hidden" outlined>
                            <v-simple-table class="text-primary" dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th>Números</th>
                                    <th>Vigencia</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="(c, i) in orderedCafs[d.document.id]">
                                    <tr :key="i">
                                      <td>
                                        <span class="text--secondary font-weight-medium">{{c.from_number}}</span> al <span class="text--secondary font-weight-medium">{{c.to_number}}</span>
                                        <template v-if="d.next_number >= c.from_number && d.next_number <= c.to_number">
                                          <v-chip v-if="!cafIsLive(c.life_to)" class="ml-2" color="red lighten-5" text-color="red" small>Vencido</v-chip>
                                          <v-chip v-else class="ml-2" color="lightBlue" text-color="primary" small>En uso</v-chip>
                                        </template>
                                      </td>
                                      <td>desde <span class="text--secondary font-weight-medium">{{c.life_from | date}}</span> hasta <span class="text--secondary font-weight-medium">{{c.life_to | date}}</span></td>
                                    </tr>
                                  </template>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    <v-divider />
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-row class="mx-0" v-else>
                  <v-col class="py-5 text-center">
                    <v-icon class="d-block" color="secondary" size="70">mdi-numeric-0-box-multiple</v-icon>
                    <span class="d-block subtitle-1 my-2">Aún no tienes folios</span>
                    <v-btn @click="dialogCreateFolio=true" outlined>Subir folio</v-btn>
                  </v-col>
                </v-row>
              </template>
              <v-row class="mx-1 py-3">
                <v-col class="py-0" cols="12">
                  <v-list-item class="px-0">
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Ayuda</v-list-item-title>
                  </v-list-item>
                  <v-list class="transparent">
                    <v-list-item class="px-0">
                      <v-list-item-title>
                        <v-btn :href="`${$DOCS_BASE}${guides[0]}`" target="_blank" text color="primary" :ripple="false">Cómo solicitar timbraje de folios en SII<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-title>
                        <v-btn :href="`${$DOCS_BASE}${guides[1]}`" target="_blank" text color="primary" :ripple="false">Cómo subir folios<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-title>
                        <v-btn :href="`${$DOCS_BASE}${guides[2]}`" target="_blank" text color="primary" :ripple="false">Cómo anular folios vencidos<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- end folio -->

          <!-- tax settings -->
          <v-card ref="taxsettings" class="my-5">
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información fiscal</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0 background">
              <v-list class="py-6" color="transparent">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text--secondary font-weight-medium">Descripción de actividad</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8" class="pa-0">
                        <v-text-field v-model="$v.billerConnection.activity_description.$model" :error="$v.billerConnection.activity_description.$error" background-color="white" outlined required single-line dense  maxlength="64" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text--secondary font-weight-medium">Código de actividad SII</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8" class="pa-0">
                        <v-select v-model="$v.billerConnection.activity.$model" :error="$v.billerConnection.activity.$error" :items="activitiesList" item-text="name" item-value="id" hide-details single-line dense height="30" outlined background-color="white" />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      <v-row align="center" no-gutters>
                        <v-col cols="3" class="pa-0">
                          <span class="body-2 text--secondary font-weight-medium">Fecha de resolución</span>
                          <v-menu v-model="menu" :close-on-content-click="false" offset-y transition="scale-transition">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="$v.billerConnection.resolution_date.$model" :error="$v.billerConnection.resolution_date.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                                <template v-slot:append>
                                  <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="$v.billerConnection.resolution_date.$model" no-title @input="menu = false" type="date" locale="es-cl" width="280" color="primary">
                              <div class="mx-auto">
                              <v-btn color="primary" @click="() => { $v.billerConnection.resolution_date.$model = today; menu = false }">Hoy</v-btn>
                              <v-btn class="ml-2" outlined @click="() => {$v.billerConnection.resolution_date.$model = ''; menu = false}">Limpiar</v-btn>
                              </div>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="3" class="pa-0 pl-3">
                          <span class="body-2 text--secondary font-weight-medium">Número de resolución</span>
                          <v-text-field v-model.trim="$v.billerConnection.resolution_number.$model" :error="$v.billerConnection.resolution_number.$error" background-color="white" outlined required single-line dense  hide-details />
                        </v-col>
                      </v-row>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text--secondary font-weight-medium">
                      <v-switch class="mt-n4" v-model="billerConnection.invoice_assignable_copy" style="position:absolute" label="Agregar cedible en la factura" />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text--secondary font-weight-medium">
                      <v-switch class="mt-n4" v-model="billerConnection.test_mode" style="position:absolute" label="Activar el modo de prueba" />
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn @click="instance.id ? updateBillerConnection() : createBillerConnection()" :loading="$store.state.billers.createLoader" color="primary">Guardar</v-btn>
            </v-card-actions>
          </v-card>
          <!-- end tax settings -->

          <!-- imports -->
          <v-card class="my-5">
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Importaciones</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0 background">
              <v-list class="transparent">
                <v-list-item v-for="d in imports" :key="d.title" three-line style="border-bottom: 1px solid #D8E0EA">
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text--secondary font-weight-medium">{{d.title}}</v-list-item-title>
                    <v-list-item-subtitle>{{d.description}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="mt-7">
                  <v-btn class="font-weight-medium" :to="{ name: `${d.url}` }" text color="primary" :ripple="false">Importar
                    <v-icon color="primary" small>mdi-arrow-right</v-icon>
                  </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
          <!-- end imports -->
        </v-col>
      </v-row>
    </v-col>

    <!-- dialog create folio -->
    <v-dialog v-model="dialogCreateFolio" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Subir folios</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogCreateFolio=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-col cols="10" class="mx-auto">
            <v-list class="transparent">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-file-input v-model="newCaf.file" ref="newCaf" type="file" :error="$v.newCaf.file.$error" accept=".xml" prepend="mdi-paper-clip" background-color="transparent" hide-details placeholder="No se eligió ningún archivo" solo flat chips />
                  </v-list-item-title>
                  <v-list-item-subtitle class="pt-3">Selecciona o arrastra un archivo de folios obtenidos desde sii.cl</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogCreateFolio=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="createCaf" :loading="$store.state.billers.createLoader" color="primary">Subir folio</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog create folio -->

    <!-- dialog certificate -->
    <v-dialog v-model="modalCertificate" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Nuevo certificado digital</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="modalCertificate=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-0 py-4 background">
          <v-list class="v-list-form transparent">
            <v-list-item class="py-2">
              <v-list-item-title>
                Archivo del certificado
                <v-tooltip right transition="scale-transition" max-width="280px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Asegúrate que el certificado digital tenga formato/extensión .p12</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-file-input v-model="newCertificate.file" ref="newCertificate.file" :error="$v.newCertificate.file.$error" type="file" accept="application/x-pkcs12" prepend="mdi-paper-clip" background-color="transparent" hide-details placeholder="No se eligió ningún archivo" solo flat chips />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title>
                Contraseña
                <v-tooltip right transition="scale-transition" max-width="280px">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>La contraseña que ingresaste al comprar el certificado digital</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-text-field v-model="$v.newCertificate.password.$model" :error="$v.newCertificate.password.$error" type="password" background-color="white" outlined required single-line dense hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="modalCertificate=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="createCertificate" :loading="$store.state.billers.createLoader" color="primary">Subir certificado</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog certificate -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, numeric } from 'vuelidate/lib/validators'
import moment from 'moment'
import GenericViewMixin from '@/mixins/GenericViewMixin'

import billers from '../../../../collections/billers'

const biller = billers.find(b => b.id === 'built_in')

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    biller: biller,
    expansionPanelCafs: null,
    guides: [
      '/integrations/billers/facturacion-incorporada/chile-sii#solicitar-folios-en-sii',
      '/integrations/billers/facturacion-incorporada/chile-sii#solicitar-folios-en-sii',
      '/integrations/billers/facturacion-incorporada/chile-sii#anulacion-de-folios-vencidos'
    ],
    menu: false,
    file: null,
    hasBillerConnection: true,
    hasCertificate: true,
    hasSequences: true,
    imports: [
      {
        title: 'Facturas',
        description: 'Importa documentos de venta desde archivos XML.',
        ref: '',
        url: 'AccountImportInvoices'
      },
      {
        title: 'Notas de crédito',
        description: 'Importa las notas de crédito desde archivos XML. Es requerido que la factura exista previamente en Piriod.',
        ref: '',
        url: 'AccountImportCreditNotes'
      }
    ],
    mainLoader: false,
    modalCertificate: false,
    newCaf: {
      file: null
    },
    newCertificate: {
      file: null,
      password: ''
    },
    billerConnection: {
      test_mode: false,
      activity: null,
      activity_description: '',
      resolution_date: '',
      resolution_number: null,
      invoice_assignable_copy: false
    },
    editableSequence: {
      next_number: null
    },
    dialogCreateFolio: false,
    sequenceDocuments: ['CL33', 'CL34', 'CL39', 'CL41', 'CL46', 'CL52', 'CL56', 'CL61', 'CL110', 'CL111', 'CL112']
  }),
  computed: {
    ...mapState({
      activitiesList: state => state.billers.activitiesList,
      instance: state => state.billers.billerconnectionsList[0] || {},
      cafsList: state => state.billers.cafsList,
      certificatesDetail: state => state.billers.certificatesList[0] || [],
      sequencesList: state => state.invoices.sequencesList
    }),
    activation () {
      const steps = 3
      const complete = Number(this.hasCertificate) + Number(this.hasSequences) + Number(this.hasBillerConnection)
      return Math.round(complete / steps * 100)
    },
    orderedCafs () {
      const documentTypes = this.sequencesList.map(s => s.document.id)
      const orderedCafs = {}

      documentTypes.forEach(d => {
        orderedCafs[d] = this.cafsList.filter(c => c.document === d)
      })

      return orderedCafs
    }
  },
  created () {
    this.mainLoader = true

    Promise.all([
      this.$store.dispatch('billers/LIST', {
        resource: 'billerconnections',
        query: {
          biller: 'built_in'
        }
      }),
      this.$store.dispatch('billers/LIST', {
        resource: 'billers/built_in/certificates',
        query: {
          page_size: 1
        }
      }),
      this.$store.dispatch('invoices/LIST', {
        resource: 'sequences',
        query: {
          document__id__in: this.sequenceDocuments.join(','),
          expand: 'document',
          page_size: 100
        }
      }),
      this.$store.dispatch('billers/LIST', {
        resource: 'billers/built_in/activities',
        query: {
          page_size: 1000
        }
      })
    ])
    .then(() => {
      if (!this.certificatesDetail.name) {
        this.hasCertificate = false
      }
    })
    .then(() => {
      if (this.sequencesList.length) {
        this.$store.dispatch('billers/LIST', {
          resource: 'billers/built_in/cafs',
          query: {
            page_size: 100
          }
        })
      } else {
        this.hasSequences = false
      }
    })
    .then(() => {
      if (this.instance.id) {
        Object.keys(this.billerConnection).forEach(k => {
          this.billerConnection[k] = this.instance.extra_data[k]
        })
      } else {
        this.hasBillerConnection = false
      }
    })
    .finally(() => {
      this.mainLoader = false
    })
  },
  mounted () {
    setTimeout(() => {
      if (this.$route.query.ref && this.$refs[this.$route.query.ref]) {
        this.$vuetify.goTo(this.$refs[this.$route.query.ref].$el, { offset: 20 })
      }
    }, 1500)
  },
  methods: {
    cafExists (document, nextNumber) {
      return this.orderedCafs[document].find(c => nextNumber >= c.from_number && nextNumber <= c.to_number && this.cafIsLive(c.life_to))
    },
    cafIsLive (endDate) {
      return moment(endDate).isSameOrAfter(this.today)
    },
    createCertificate () {
      this.$v.newCertificate.$touch()
      if (this.$v.newCertificate.$invalid) {
        return false
      }

      const payload = new FormData()
      payload.append('file', this.newCertificate.file, this.newCertificate.file.name)
      payload.append('password', this.newCertificate.password)

      this.$store.dispatch('billers/CREATE', {
        resource: 'billers/built_in/certificates',
        payload: payload,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(() => {
        this.$store.dispatch('billers/LIST', {
          resource: 'billers/built_in/certificates',
          query: {
            page_size: 1
          }
        })

        this.hasCertificate = true
        this.modalCertificate = false
        this.newCertificate = {
          file: null,
          password: ''
        }
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    createCaf () {
      this.$v.newCaf.$touch()
      if (this.$v.newCaf.$invalid) {
        return false
      }

      const payload = new FormData()
      payload.append('file', this.newCaf.file, this.newCaf.file.name)

      this.$store.dispatch('billers/CREATE', {
        resource: 'billers/built_in/cafs',
        payload: payload,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(() => {
        this.$store.dispatch('invoices/LIST', {
          resource: 'sequences',
          query: {
            document__id__in: this.sequenceDocuments.join(','),
            expand: 'document',
            page_size: 100
          }
        })
        .then(() => {
          this.dialogCreateFolio = false
          this.newCaf.file = null
        })

        this.hasSequences = true
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    createBillerConnection () {
      this.$v.billerConnection.$touch()

      if (this.$v.billerConnection.$invalid) {
        return false
      }

      const payload = {
        api_key: 'api_key',
        biller: 'built_in',
        extra_data: this.billerConnection
      }

      this.$store.dispatch('billers/CREATE', {
        resource: 'billerconnections',
        payload: payload
      })
      .then(() => {
        this.hasBillerConnection = true
        this.$dialog.message.info('La información fiscal de la organización se ha actualizado')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    updateBillerConnection () {
      this.$v.billerConnection.$touch()

      if (this.$v.billerConnection.$invalid) {
        return false
      }

      const payload = {
        extra_data: this.billerConnection
      }

      this.$store.dispatch('billers/UPDATE', {
        resource: 'billerconnections',
        id: this.instance.biller,
        payload: payload
      })
      .then(() => {
        this.hasBillerConnection = true
        this.$dialog.message.info('La información fiscal de la organización se ha actualizado')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    newCertificate: {
      file: {
        required
      },
      password: {
        required
      }
    },
    newCaf: {
      file: {
        required
      }
    },
    billerConnection: {
      activity: {
        required
      },
      activity_description: {
        required,
        maxLength: maxLength(56)
      },
      resolution_date: {
        required
      },
      resolution_number: {
        required,
        numeric
      }
    }
  }
}
</script>